// In a new file Flashcards/security-terms.js
export const FlashcardQuestions = [
    {
        id: "term_1",
        term: "Buffer Overflow",
        definition: "A buffer overflow occurs when a program tries to write more data than the allocated space in its memory, potentially allowing attackers to execute malicious code.",
        domain: "Security Operations",
        difficulty: 0.5
    },
    {
        id: "term_2",
        term: "Zero-Day Exploit",
        definition: "A cyber attack that occurs on the same day a weakness is discovered in software. At that point, it's exploited before a fix becomes available from its creator.",
        domain: "Threats, Vulnerabilities and Mitigations",
        difficulty: 0.5
    },
    // Add more terms here...
];